import React from 'react'
import { Link } from 'react-router-dom'
import Blog_1 from '../../../assets/images/home_page_3/blog-post/01.png'
import Blog_2 from '../../../assets/images/home_page_3/blog-post/02.png'
import Blog_3 from '../../../assets/images/home_page_3/blog-post/03.png'

const Blog = () => {
    return (
        <>
            <section id="blog-post-three" className="blog-post-three-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <div className="section">
                                <h4 className="section-title-three">Blog post</h4>
                                <p>Discover the most Trending post</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <Link
                                to="/blog"
                                className="btn btn-secondary float-start float-md-end float-lg-end"
                                title=""
                            >
                                See All Post <i className="flaticon-chevron" />
                            </Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="blog-post-three-block">
                                <div className="blog-post-three-img">
                                    <Link to="/Blogdetails" title="">
                                        <img
                                            src={Blog_1}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </Link>
                                </div>
                                <div className="blog-post-three-dtl">
                                    <span className="badge text-bg-primary">26 Nov 2025</span>
                                    <h5 className="blog-post-three-title jakarta-font">
                                        <Link to="/Blogdetails" title="">
                                            Style Diaries A Journey Through in the Evolution of 2023 Fashion
                                        </Link>
                                    </h5>
                                    <Link to="/Blogdetails" className="btn btn-secondary" title="">
                                        Read More <i className="flaticon-chevron" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="blog-post-three-block">
                                <div className="blog-post-three-img">
                                    <Link to="/Blogdetails" title="">
                                        <img
                                            src={Blog_2}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </Link>
                                </div>
                                <div className="blog-post-three-dtl blog-post-three-dtl-one">
                                    <span className="badge text-bg-primary">26 Nov 2025</span>
                                    <h6 className="blog-post-three-title jakarta-font">
                                        <Link to="/Blogdetails" title="">
                                            A Journey Through in the Evolution of 2023 Fashion
                                        </Link>
                                    </h6>
                                    <Link to="/Blogdetails" className="btn btn-secondary" title="">
                                        Read More <i className="flaticon-chevron" />
                                    </Link>
                                </div>
                            </div>
                            <div className="blog-post-three-block">
                                <div className="blog-post-three-img">
                                    <Link to="/Blogdetails" title="">
                                        <img
                                            src={Blog_3}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </Link>
                                </div>
                                <div className="blog-post-three-dtl blog-post-three-dtl-two">
                                    <span className="badge text-bg-primary">26 Nov 2025</span>
                                    <h6 className="blog-post-three-title jakarta-font">
                                        <Link to="/Blogdetails" title="">
                                            A Journey Through in the Evolution of 2023 Fashion
                                        </Link>
                                    </h6>
                                    <Link to="/Blogdetails" className="btn btn-secondary" title="">
                                        Read More <i className="flaticon-chevron" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Blog
